import Vue from 'vue'
import Buefy from 'buefy'
import 'buefy/lib/buefy.css'
import '../../assets/css/farsoft.css'

Vue.use(Buefy)

// OR

// Vue.component(Buefy.Checkbox.name, Buefy.Checkbox)
// Vue.component(Buefy.Table.name, Buefy.Table)
// Vue.component(Buefy.Switch.name, Buefy.Switch)
